<template>
  <v-footer
    class="app footer justify-center caption"
  >
    Grupo Dataclick &copy; {{ $t('version') }} {{ version }} ({{ commit }})
  </v-footer>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  computed: {
    version() {
      return import.meta.env.__APP_VERSION__
    },
    commit() {
      return import.meta.env.__COMMIT__.trim()
    }
  }
})
</script>